import { render } from "./dialogDetail.vue?vue&type=template&id=ed923be6"
import script from "./dialogDetail.vue?vue&type=script&lang=js"
export * from "./dialogDetail.vue?vue&type=script&lang=js"

import "./dialogDetail.vue?vue&type=style&index=0&id=ed923be6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__